// 主标题最大字数
export const MAIN_TITLE_SIZE = 8;
// 副标题最大字数
export const SUB_TITLE_SIZE = 14;
// 按钮点击时透明度
export const ACTIVE_OPACITY = 0.7;
